
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["mx-auto",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.05 23.759c.004-.155.01-.315.01-.475 0-5.265-4.27-9.53-9.53-9.53-5.265 0-9.53 4.27-9.53 9.53 0 .16.005.315.01.475","stroke":"#000","stroke-miterlimit":"10","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M10.516 10.952c2.595 0 4.7-2.228 4.7-4.976 0-2.748-2.105-4.976-4.7-4.976-2.596 0-4.7 2.228-4.7 4.976 0 2.748 2.104 4.976 4.7 4.976z","stroke":"#000","stroke-miterlimit":"10"}})])
          )
        }
      }
    